import type {
  GroupSortDirection,
  GroupsListResponse,
  SortableGroupColumn,
} from '@app/application/user-management/types'

import { GROUPS_REQUEST_KEY } from '@app/application/user-management/constants'
import { getSignal } from '@app/adapters/abort'
import SFetch from '@app/utils/sfetch'

export const fetchGroups = ({
  q,
  sortBy,
  sortDirection,
  page = 1,
}: {
  q?: string
  sortBy?: SortableGroupColumn
  sortDirection?: GroupSortDirection
  page?: number
} = {}): Promise<GroupsListResponse | null> =>
  SFetch.json<GroupsListResponse>(
    window.Silverfin.Routes.groups_path(window.Silverfin.currentFirmId, {
      format: 'json',
      q,
      sort_by: sortBy,
      sort_direction: sortDirection,
      page,
    }),
    { signal: getSignal(GROUPS_REQUEST_KEY) }
  )
